import { components } from 'react-select';
import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

export default function CustomOption({ data, ...rest }) {
  return (
    <S.OptionContainer>
      {data.shieldImageUrl && <S.DropdownImage src={data.shieldImageUrl} />}
      <components.Option {...rest} />
    </S.OptionContainer>
  );
}

CustomOption.propTypes = {
  data: PropTypes.object,
};

CustomOption.defaultProps = {
  data: null,
};
